let globalTermsCondition = {};

const updateGlobalTermsConditions = (newTermsConditions) => {
  globalTermsCondition = { ...globalTermsCondition, ...newTermsConditions };
};

const getGlobalTermsCondition = () => globalTermsCondition;

export { updateGlobalTermsConditions, getGlobalTermsCondition };
